module.exports = __webpack_public_path__ + "static/img/wjfz_icon.14c23a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImage/wjfz_icon.png
// module id = nVw8
// module chunks = 0